module.exports = __webpack_public_path__ + "img/ebay_logo.bc6729bc.png";